import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";

import "animate.css/animate.css";

const ThirdModal = ({
  classes,
  nextQuestion,
  handleClose,
  answeredCorrectly,
  question,
  isOpen
}) => {
  return (
    <Modal open={isOpen}
    className="animate__animated animate__fadeInRight"
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Typography className={classes.stepNumber}>STEP 3</Typography>
          {/* <Grid container justify="center" className={classes.mainLine}>Now we have only people that in the labor force, you can decide which "Friends" are employed or unemployed.</Grid> */}
          <Typography className={classes.evalDesc}>
          Now that we have classified our friends as employed, unemployed or out of the labor force we can calculate the both the Labor Force Participation rate and the Unemployment Rate.
          </Typography>
          <Grid container justify="center" style={{ padding: 24 }}>
            <Button className={classes.submitButton} onClick={handleClose}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(ThirdModal);
